/* ==========================================================================
   MAPLE BELLA CART EXTRAS  (assets/em-cart-extras.js)
   Keeps the cart count, upsell and totals in sync. Listens on the theme's
   own `cart:updated` event (dispatched by theme.CartForm). Does NOT touch
   theme.js — it only reads cart state, and adds upsell items via /cart/add.js
   then lets the theme rebuild the drawer.

   The stack & save ladder was removed; the ladder helpers below simply no-op
   when their DOM hooks are absent, so nothing breaks.
   ========================================================================== */
(function () {
  'use strict';

  var STACK = '[data-em-stack]';

  function getStack() { return document.querySelector(STACK); }

  // ---- ladder rendering -------------------------------------------------
  function parseList(str) {
    return (str || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
  }

  function moneyCountFromCart(cart) {
    // item_count = total quantity across lines (matches Liquid cart.item_count)
    return cart && typeof cart.item_count === 'number' ? cart.item_count : null;
  }

  function updateLadder(count) {
    var stack = getStack();
    if (count !== null) {
      // update the "CART (n)" title count
      var countEls = document.querySelectorAll('[data-em-count]');
      countEls.forEach(function (el) { el.textContent = '(' + count + ')'; });
    }
    if (!stack || count === null) return;

    var tiers = parseList(stack.getAttribute('data-tiers'));      // [2,3,4,5]
    var discounts = parseList(stack.getAttribute('data-em-discounts')); // [10,15,20,25]
    stack.setAttribute('data-count', String(count));

    // tier dom nodes are keyed 1..5 via data-em-tier
    var tierEls = stack.querySelectorAll('[data-em-tier]');
    var nextNeeded = count + 1;

    tierEls.forEach(function (el) {
      var tnum = parseInt(el.getAttribute('data-em-tier'), 10);
      el.classList.remove('em-cart__tier--reached', 'em-cart__tier--next', 'em-cart__tier--locked');
      if (count >= tnum) {
        el.classList.add('em-cart__tier--reached');
      } else if (tnum === nextNeeded) {
        el.classList.add('em-cart__tier--next');
      } else {
        el.classList.add('em-cart__tier--locked');
      }
    });

    // progress line fill: from first tier position to current count position.
    // positions are evenly spaced across 5 columns (centers at 10%,30%,50%,70%,90%).
    var fill = stack.querySelector('[data-em-line-fill]');
    if (fill) {
      var centers = [10, 30, 50, 70, 90];
      var idx = Math.max(0, Math.min(centers.length - 1, count - 1));
      // the line element is inset 6% on each side (88% wide). Map center% to that.
      var pct;
      if (count <= 1) {
        pct = 0;
      } else {
        // distance from first center(10) to current center, over the line's own width
        var start = centers[0];
        var cur = centers[idx];
        pct = ((cur - start) / (centers[centers.length - 1] - start)) * 100;
      }
      fill.style.width = pct + '%';
    }

    // status message
    var status = stack.querySelector('[data-em-stack-status]');
    if (status) {
      var msg;
      // find the next tier above current count
      var nextTierPct = null;
      for (var i = 0; i < tiers.length; i++) {
        if (count < tiers[i]) { nextTierPct = discounts[i]; break; }
      }
      if (nextTierPct === null) {
        // at or beyond top tier
        msg = discounts[discounts.length - 1] + '% off unlocked';
      } else {
        msg = 'Add 1 more for <b>' + nextTierPct + '% off</b>';
      }
      status.innerHTML = msg;
    }

    updateUpsellSub(count, tiers, discounts);
  }

  // ---- upsell sub-line (removed; no-ops if the hook is absent) ----------
  function updateUpsellSub(count, tiers, discounts) {
    var sub = document.querySelector('[data-em-upsell-sub]');
    if (!sub) return;
    var nextTierPct = null;
    for (var i = 0; i < tiers.length; i++) {
      if (count < tiers[i]) { nextTierPct = discounts[i]; break; }
    }
    if (nextTierPct === null) {
      sub.textContent = 'You’ve unlocked the top tier';
    } else {
      sub.textContent = 'One more piece away from ' + nextTierPct + '% off';
    }
  }

  // ---- totals breakdown (Subtotal / Discount / Total) -------------------
  function fmtMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }
  function tierPctFor(count) {
    if (count >= 5) return 25;
    if (count === 4) return 20;
    if (count === 3) return 15;
    if (count === 2) return 10;
    return 0;
  }
  function updateTotals(cart) {
    if (!cart) return;
    var sub = document.querySelector('[data-em-subtotal]');
    if (sub) sub.innerHTML = fmtMoney(cart.original_total_price != null ? cart.original_total_price : cart.items_subtotal_price);
    var tot = document.querySelector('[data-em-total]');
    if (tot) tot.innerHTML = fmtMoney(cart.total_price);
    var dwrap = document.querySelector('[data-em-totaldisc]');
    if (dwrap) {
      // Backend-driven: amount from cart.total_discount, % from the real applied
      // discount (a code the customer entered). Never hardcoded.
      var disc = cart.total_discount || 0;
      if (disc > 0) {
        var pct = 0;
        (cart.items || []).forEach(function (it) {
          (it.line_level_discount_allocations || []).forEach(function (al) {
            if (al.discount_application && al.discount_application.value_type === 'percentage') {
              pct = Math.round(parseFloat(al.discount_application.value));
            }
          });
        });
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          if (d.value_type === 'percentage') pct = Math.round(parseFloat(d.value));
        });
        dwrap.innerHTML = '<div class="em-cart__trow em-cart__trow--save"><span>Discount' +
          (pct > 0 ? ' (' + pct + '%)' : '') + '</span><span>−' + fmtMoney(disc) + '</span></div>';
      } else {
        dwrap.innerHTML = '';
      }
    }
  }

  // ---- upsell add -------------------------------------------------------
  function addVariant(variantId, btn) {
    if (!variantId) return;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        // Let the theme rebuild the drawer + counter the same way it does
        // after a quantity change. theme.CartForm listens for cart:build.
        document.dispatchEvent(new CustomEvent('cart:build'));
        // Also fetch fresh cart to update our ladder immediately.
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateLadder(moneyCountFromCart(cart));
        // dispatch cart:updated too so any other listeners stay in sync
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        if (btn) { btn.textContent = '✓ Added'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200); }
        // remove this card from the carousel (it's now in cart)
        var card = btn && btn.closest('[data-em-upcard]');
        if (card) { setTimeout(function () { card.remove(); }, 1300); }
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      });
  }

  // ---- events -----------------------------------------------------------
  function bind() {
    // theme dispatches cart:updated with detail.cart after qty changes
    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      if (cart) { updateLadder(moneyCountFromCart(cart)); updateTotals(cart); }
    });

    // PDP add-to-cart: theme.js only rebuilds the items, not our totals.
    // Re-sync them so the count + totals stay correct.
    document.addEventListener('ajaxProduct:added', function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateLadder(moneyCountFromCart(cart)); updateTotals(cart); })
        .catch(function () {});
    });

    // delegate clicks for upsell add + carousel nav
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-em-upadd]');
      if (add) {
        e.preventDefault();
        addVariant(add.getAttribute('data-variant-id'), add);
        return;
      }
      var prev = e.target.closest('[data-em-upsell-prev]');
      var next = e.target.closest('[data-em-upsell-next]');
      if (prev || next) {
        e.preventDefault();
        var scroll = document.querySelector('[data-em-upsell-scroll]');
        if (!scroll) return;
        var card = scroll.querySelector('[data-em-upcard]');
        var step = card ? card.offsetWidth : scroll.offsetWidth;
        scroll.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
      }
    });

    // upsell variant select changes which variant Add will add
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-em-upvariant]');
      if (!sel) return;
      var card = sel.closest('[data-em-upcard]');
      var addBtn = card && card.querySelector('[data-em-upadd]');
      if (addBtn) addBtn.setAttribute('data-variant-id', sel.value);
    });
  }

  function init() {
    bind();
    // initial sync from Liquid-rendered count (already correct on first paint,
    // but this also fixes the line fill width which needs JS)
    var stack = getStack();
    if (stack) {
      var c = parseInt(stack.getAttribute('data-count'), 10);
      if (!isNaN(c)) updateLadder(c);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
